export enum EnrollmentPacketSaveContext {
  USER_PROFILE_ACTION = 'user-profile-action',
  PACKET_ACTION = 'packet-action',
}
